import React from "react";
import './LandingPage.css';
import Header from '../Header/Header.jsx'
import Intro from '../Intro/Intro.jsx'
import CoreProducts from '../CoreProducts/CoreProducts.jsx'
import CaseStudies from '../CaseStudies/CaseStudies.jsx'
import KineticProcess from '../KineticProcess/KineticProcess.jsx'
import KindWords from '../KindWords/KindWords.jsx'
import Logos from '../Logos/Logos.jsx'
import Publications from '../Publications/Publications.jsx'
import Team from '../Team/Team.jsx'
import Contact from '../Contact/Contact.jsx'
import Footer from '../Footer/Footer.jsx'

import "animate.css/animate.min.css";

export default class LandingPage extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			isMenuOpen: false
		}
	}

	render() {

		return (
			<>
			<Header onOpen={(isOpen)=>{this.setState({isMenuOpen:isOpen})}}/>
			<div className={this.state.isMenuOpen?"landing-page-container opened-menu":"landing-page-container"}>
				<Intro />
				<CoreProducts />
				<CaseStudies />
				<KineticProcess />
				<KindWords />
				<Logos />
				<Publications />
				<Team />
				<Contact />
				<Footer />
			</div>
			</>
		);
	}
}
